import { SxProps, Theme } from '@mui/material';
import { QuoteType } from '@lio/rule-engine';
import { RelatedTransactionsTab } from '../types';
import { QuoteStatus } from '@models/quotes';

// note: this is intentionally high due to policy term calculation failing if we do not have all transactions
// IE need new business to properly calculate terms with the "should start new term" logic
export const PAGE_SIZE = 200;

// Shared styles for highlighting the current/active item
export const currentItemStyles = (isCurrent: boolean): SxProps<Theme> => ({
  backgroundColor: isCurrent ? 'rgba(0, 0, 0, 0.04)' : 'transparent',
  borderLeft: '3px solid',
  borderLeftColor: isCurrent ? 'primary.main' : 'transparent',
  borderRadius: '2px',
});

// Shared styles for the external link icon
export const externalLinkIconStyle = { color: '#757575', verticalAlign: 'middle' } as const;

export const TERM_STARTING_TRANSACTION_TYPES = [QuoteType.NewBusiness, QuoteType.Renewal];

export const TAB_CONFIG = {
  [RelatedTransactionsTab.Policy]: {
    label: 'Policy',
    tabSearchParam: 'policy',
  },
  [RelatedTransactionsTab.Customer]: {
    label: 'Customer',
    tabSearchParam: 'customer',
  },
};

export const NON_BOUND_QUOTE_STATUSES = [
  QuoteStatus.Submission.queryParam,
  QuoteStatus.ReadyForRating.queryParam,
  QuoteStatus.Rated.queryParam,
  QuoteStatus.Underwritten.queryParam,
  QuoteStatus.ReadyToBind.queryParam,
  QuoteStatus.Referred.queryParam,
  QuoteStatus.Declined.queryParam,
  QuoteStatus.Rejected.queryParam,
  QuoteStatus.Canceled.queryParam,
  QuoteStatus.Expired.queryParam,
];
